<div style="max-width:400px">
    <dw-message [(message)]="message"></dw-message>
</div>

<app-payment-card-details [(cardDetails)]="cardAddRequest.cardDetails"
    [showAddTestCardInfo]="showAddTestCardInfo"></app-payment-card-details>

<div dwRow>
    <div dwCol="6">
        <label>
            <span class="pilexos-checkbox">
                <input type="checkbox" [(ngModel)]="cardAddRequest.makeDefaultCard">
                <span>Set as Default</span>
            </span>
        </label>
    </div>
</div>